var _defs, _ellipse, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _g, _rect4, _rect5, _circle4, _circle5, _path, _path2, _path3, _path4, _circle6, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 200,
    viewBox: "0 0 240 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendarEmptyHeaderGradient",
    x1: 70,
    y1: 75,
    x2: 170,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7579E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BD7E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calendarEmptyPageClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 75,
    width: 100,
    height: 112,
    rx: 14
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 194,
    rx: 58,
    ry: 6,
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 150,
    r: 4,
    fill: "#CBCED5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 70,
    r: 3,
    fill: "#CBCED5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 150,
    r: 5,
    fill: "#FFEFB7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 66,
    width: 7,
    height: 16,
    rx: 3.5,
    fill: "#FFFFFF",
    stroke: "#7579E7",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 66,
    width: 7,
    height: 16,
    rx: 3.5,
    fill: "#FFFFFF",
    stroke: "#7579E7",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 66,
    width: 7,
    height: 16,
    rx: 3.5,
    fill: "#FFFFFF",
    stroke: "#7579E7",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendarEmptyPageClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 75,
    width: 100,
    height: 112,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 75,
    width: 100,
    height: 30,
    fill: "url(#calendarEmptyHeaderGradient)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 75,
    width: 100,
    height: 112,
    rx: 14,
    fill: "none",
    stroke: "#CBCED5",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 83,
    width: 18,
    height: 14,
    rx: 4,
    fill: "#FFFFFF",
    fillOpacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 90,
    r: 1.6,
    fill: "#7579E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 90,
    r: 1.6,
    fill: "#7579E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82,122 L158,122",
    stroke: "#EBEBEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82,138 L158,138",
    stroke: "#EBEBEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82,154 L158,154",
    stroke: "#EBEBEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82,170 L158,170",
    stroke: "#EBEBEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 122,
    r: 5,
    fill: "#95E3BC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 26,
    width: 72,
    height: 56,
    rx: 12,
    fill: "#F6F6F6",
    stroke: "#CBCED5",
    strokeWidth: 1.5,
    strokeDasharray: "4 5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 42,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 55,
    width: 36,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 68,
    width: 26,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 26,
    r: 12,
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,20 L224,32 M218,26 L230,26",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEmpty);
export default __webpack_public_path__ + "static/media/calendar_empty.21dcb4383b3eac1e2c01699e0faa9c89.svg";
export { ForwardRef as ReactComponent };